import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import styled from "styled-components";

import { Breadcrumb } from "antd";

import ShowroomForms from "./components/showroom-forms";
import ShowroomList from "./components/showroom-list";

export const StyledBreadcrumb = styled(Breadcrumb)`
    background: #fff;
    display: flex;
    padding: 16px 25px;
`;

const ManageShowroom = (): JSX.Element => {
    const match = useRouteMatch();
    return (
        <>
            <Switch>
                <Route
                    exact
                    path={`${match.path}`}
                    render={(props: any) => <ShowroomList {...props} />}
                />
                <Route
                    exact
                    path={`${match.path}/add`}
                    render={(props: any) => <ShowroomForms {...props} />}
                />
                <Route
                    exact
                    path={`${match.path}/:slug`}
                    render={(props: any) => <ShowroomForms {...props} />}
                />
            </Switch>
        </>
    );
};

export default ManageShowroom;
